import { apiClient } from './api';

/**
 * Invoices Service
 * Handles all invoice-related API calls
 */
export const invoicesService = {
  /**
   * List invoices
   * @param {Object} params - Query parameters (status, start_date, end_date, search, account_id, page, per_page)
   * @returns {Promise} Invoices list
   */
  list: (params = {}) => {
    return apiClient.get('/finance/invoices', params);
  },

  /**
   * Get invoice by ID
   * @param {number} id - Invoice ID
   * @returns {Promise} Invoice data
   */
  get: (id) => {
    return apiClient.get(`/finance/invoices/${id}`);
  },

  /**
   * Approve invoice
   * @param {number} id - Invoice ID
   * @param {Object} data - Approval data (optional approval_notes)
   * @returns {Promise} Approved invoice
   */
  approve: (id, data = {}) => {
    return apiClient.post(`/finance/invoices/${id}/approve`, data);
  },

  /**
   * Download invoice as PDF (if backend endpoint exists)
   * @param {number} id - Invoice ID
   * @returns {Promise} PDF file download
   */
  downloadPdf: (id) => {
    return apiClient.get(`/finance/invoices/${id}/download/pdf`, {}, { responseType: 'blob' });
  },
};
